/*global fpf_product*/
export default class SummaryDisplayer {
	#prices = new Map();
	#priceFormatter;
	#summaryWrapper;

	constructor(priceFormatter) {
		this.#priceFormatter = priceFormatter;
		this.#summaryWrapper = document.querySelector('#fpf_totals');
		this.#validateElements();
	}

	set(fieldId, data) {
		this.#prices.set(fieldId, data);
	}

	remove(fieldId) {
		this.#prices.delete(fieldId);
	}

	display(productPrice) {
		this.#validateElements();

		const fragment = document.createDocumentFragment();
		const addonsTotal = this.#calculateAddonsTotal();

		let hasPrices = false;
		this.#prices.forEach((data) => {
			const row = this.#createPriceRow(data);
			fragment.appendChild(row);
			hasPrices = true;
		});

		if (hasPrices) {
			this.#renderTotal(productPrice + addonsTotal, fragment);
		}

		this.#summaryWrapper.replaceChildren(fragment);
	}

	#validateElements() {
		if (!this.#summaryWrapper) {
			throw new Error('Missing required element #fpf_totals');
		}
		if (!this.#priceFormatter) {
			throw new Error('PriceFormatter not initialized');
		}
	}

	#createPriceRow(data) {
		const dt = document.createElement('dt');
		dt.className = 'title';
		dt.textContent = `${data.title}${data.option_label ? ` (${data.option_label})` : ''}`;

		const dd = document.createElement('dd');
		dd.className = 'price';
		dd.textContent = this.#priceFormatter.format(data?.price || 0);

		const wrapper = document.createElement('div');
		wrapper.className = 'price-row';
		wrapper.append(dt, dd);
		return wrapper;
	}

	#calculateAddonsTotal() {
		return Array.from(this.#prices.values()).reduce((total, data) => {
			return total + (Number(data?.price) || 0);
		}, 0);
	}

	#renderTotal(productTotal, fragment) {
		const totalWrapper = document.createElement('div');
		totalWrapper.className = 'total-row';

		const dt = document.createElement('dt');
		dt.textContent = fpf_product.total;

		const dd = document.createElement('dd');
		dd.className = 'grand-total';
		dd.textContent = this.#priceFormatter.format(productTotal);

		totalWrapper.append(dt, dd);
		fragment.appendChild(totalWrapper);
	}
}
